import React from 'react';

const LABEL_CLASS = "block text-sm font-medium text-gray-700 mb-1";
const INPUT_CLASS = "w-full p-2 border rounded";

export function SizeDetectionControls({ values, onChange, disabled = false }) {
  const handle = key => event => {
    const value = parseFloat(event.target.value);
    onChange({ ...values, [key]: Number.isNaN(value) ? '' : value });
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow">
      <h3 className="font-medium text-lg mb-4">Detection Parameters</h3>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <div>
          <label className={LABEL_CLASS} htmlFor="det-prominence">Prominence</label>
          <input
            id="det-prominence"
            type="number"
            step="0.0001"
            min="0"
            value={values.prominence}
            onChange={handle('prominence')}
            className={INPUT_CLASS}
            disabled={disabled}
          />
          <p className="text-xs text-gray-500 mt-1">
            Lower values catch gentler peaks; raise to ignore tiny bumps.
          </p>
        </div>
        <div>
          <label className={LABEL_CLASS} htmlFor="det-area">Area Threshold</label>
          <input
            id="det-area"
            type="number"
            step="0.0001"
            min="0"
            value={values.area_threshold}
            onChange={handle('area_threshold')}
            className={INPUT_CLASS}
            disabled={disabled}
          />
          <p className="text-xs text-gray-500 mt-1">
            Minimum fraction of total area a peak must contribute.
          </p>
        </div>
        <div>
          <label className={LABEL_CLASS} htmlFor="det-width">Min Peak Width (s)</label>
          <input
            id="det-width"
            type="number"
            step="0.01"
            min="0"
            value={values.min_width_seconds}
            onChange={handle('min_width_seconds')}
            className={INPUT_CLASS}
            disabled={disabled}
          />
          <p className="text-xs text-gray-500 mt-1">
            Decrease for very sharp peaks; increase to ignore spikes.
          </p>
        </div>
        <div>
          <label className={LABEL_CLASS} htmlFor="det-distance">Min Peak Spacing (s)</label>
          <input
            id="det-distance"
            type="number"
            step="0.1"
            min="0"
            value={values.min_distance_seconds}
            onChange={handle('min_distance_seconds')}
            className={INPUT_CLASS}
            disabled={disabled}
          />
          <p className="text-xs text-gray-500 mt-1">
            Peaks closer than this will be merged.
          </p>
        </div>
      </div>
    </div>
  );
}
